/**
 * New TokenTypes are to be added to the end of the list. Do not change the order.
 * @codegen
 */
export var AuthTokenType;
(function (AuthTokenType) {
    AuthTokenType[AuthTokenType["EditorLowPrivilege"] = 0] = "EditorLowPrivilege";
    AuthTokenType[AuthTokenType["AugLoopLowPrivilege"] = 1] = "AugLoopLowPrivilege";
    AuthTokenType[AuthTokenType["Anonymous"] = 2] = "Anonymous";
    AuthTokenType[AuthTokenType["ClientAssertion"] = 3] = "ClientAssertion";
    AuthTokenType[AuthTokenType["ClientAssertionV2"] = 4] = "ClientAssertionV2";
    AuthTokenType[AuthTokenType["AutoClpLowPrivilege"] = 5] = "AutoClpLowPrivilege";
    AuthTokenType[AuthTokenType["AutoClpAppOnlyLowPrivilege"] = 6] = "AutoClpAppOnlyLowPrivilege";
    AuthTokenType[AuthTokenType["Substrate"] = 7] = "Substrate";
    AuthTokenType[AuthTokenType["WacUserInfo"] = 8] = "WacUserInfo";
    AuthTokenType[AuthTokenType["OwaExchange"] = 9] = "OwaExchange";
    AuthTokenType[AuthTokenType["SmartCompose"] = 10] = "SmartCompose";
    AuthTokenType[AuthTokenType["WritingAnalyticsLowPrivilege"] = 11] = "WritingAnalyticsLowPrivilege";
    AuthTokenType[AuthTokenType["DWEngineLowPrivilege"] = 12] = "DWEngineLowPrivilege";
    AuthTokenType[AuthTokenType["SubstrateApp"] = 13] = "SubstrateApp";
    AuthTokenType[AuthTokenType["CortanaAppPop"] = 14] = "CortanaAppPop";
    AuthTokenType[AuthTokenType["OfficeAppsAppOnly"] = 15] = "OfficeAppsAppOnly";
    AuthTokenType[AuthTokenType["PPTFrontdoorAppPop"] = 16] = "PPTFrontdoorAppPop";
    AuthTokenType[AuthTokenType["EditorAppOnlyLowPrivilege"] = 17] = "EditorAppOnlyLowPrivilege";
    AuthTokenType[AuthTokenType["AugLoopApp"] = 18] = "AugLoopApp";
    AuthTokenType[AuthTokenType["MeetingIntelligenceApp"] = 19] = "MeetingIntelligenceApp";
    AuthTokenType[AuthTokenType["GraphApp"] = 20] = "GraphApp";
    AuthTokenType[AuthTokenType["IceServicesApp"] = 21] = "IceServicesApp";
    /**
     * @deprecated Use MSI auth for Azure Maps resources.
     */
    AuthTokenType[AuthTokenType["AzureMapsApp"] = 22] = "AzureMapsApp";
    AuthTokenType[AuthTokenType["SpoApp"] = 23] = "SpoApp";
    AuthTokenType[AuthTokenType["OneDrive"] = 24] = "OneDrive";
    AuthTokenType[AuthTokenType["GoogleDrive"] = 25] = "GoogleDrive";
    AuthTokenType[AuthTokenType["GettyApp"] = 26] = "GettyApp";
    AuthTokenType[AuthTokenType["Dropbox"] = 27] = "Dropbox";
    AuthTokenType[AuthTokenType["GooglePhotos"] = 28] = "GooglePhotos";
    AuthTokenType[AuthTokenType["EditorApp"] = 29] = "EditorApp";
    AuthTokenType[AuthTokenType["AmazonKindle"] = 30] = "AmazonKindle";
    AuthTokenType[AuthTokenType["ShredderApp"] = 31] = "ShredderApp";
    AuthTokenType[AuthTokenType["FormsLowPrivilege"] = 32] = "FormsLowPrivilege";
    AuthTokenType[AuthTokenType["VivaSalesLowPrivilege"] = 33] = "VivaSalesLowPrivilege";
    AuthTokenType[AuthTokenType["IntentSvcApp"] = 34] = "IntentSvcApp";
    AuthTokenType[AuthTokenType["DcgLowPrivilege"] = 35] = "DcgLowPrivilege";
    AuthTokenType[AuthTokenType["CSALowPrivilege"] = 36] = "CSALowPrivilege";
    AuthTokenType[AuthTokenType["ConsumerSydneyLowPrivilege"] = 37] = "ConsumerSydneyLowPrivilege";
    AuthTokenType[AuthTokenType["CompliantSydneyApp"] = 38] = "CompliantSydneyApp";
    AuthTokenType[AuthTokenType["M365AdminApp"] = 39] = "M365AdminApp";
    AuthTokenType[AuthTokenType["MeetingArtifactsServiceLowPrivilege"] = 40] = "MeetingArtifactsServiceLowPrivilege";
    AuthTokenType[AuthTokenType["AlchemyApp"] = 41] = "AlchemyApp";
    AuthTokenType[AuthTokenType["M365Admin"] = 42] = "M365Admin";
    AuthTokenType[AuthTokenType["ConsumerShellApp"] = 43] = "ConsumerShellApp";
})(AuthTokenType || (AuthTokenType = {}));
export var UserType;
(function (UserType) {
    UserType[UserType["Unknown"] = 0] = "Unknown";
    UserType[UserType["Consumer"] = 1] = "Consumer";
    UserType[UserType["Enterprise"] = 2] = "Enterprise";
})(UserType || (UserType = {}));
/**
 * OAuth 2.0 authorization grant flow
 */
export var OAuth2GrantFlow;
(function (OAuth2GrantFlow) {
    OAuth2GrantFlow["AuthorizationCode"] = "authorization_code";
    OAuth2GrantFlow["ClientCredentials"] = "client_credentials";
    OAuth2GrantFlow["RefreshToken"] = "refresh_token";
})(OAuth2GrantFlow || (OAuth2GrantFlow = {}));
/**
 * OAuth 2.0 V2 logged in status
 */
export var OAuth2V2LoginStatus;
(function (OAuth2V2LoginStatus) {
    OAuth2V2LoginStatus[OAuth2V2LoginStatus["LoggedIn"] = 0] = "LoggedIn";
    OAuth2V2LoginStatus[OAuth2V2LoginStatus["LoggedOut"] = 1] = "LoggedOut";
})(OAuth2V2LoginStatus || (OAuth2V2LoginStatus = {}));
//# sourceMappingURL=authTypes.js.map